/* eslint-disable */
import * as type from './types';

export const setPlatformAction = (platformId) => (dispatch) => {
  dispatch({
    type: type.SET_PLATFORM,
    payload: platformId,
  });
};
